// pages/AuthCallback.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { STORAGE_KEYS } from '../../utils/constants/storageKeys';

/**
 * AuthCallback Component
 *
 * If an error is present in the query params, it redirects the user back to the login page.
 *
 * @component
 * @example
 * // Should be used in a route like "/auth/callback"
 * <Route path="/auth/callback" element={<AuthCallback />} />
 *
 * @returns {JSX.Element} Displays a loading message while processing the redirect.
 */

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const role = params.get('role');
    const error = params.get('error');

    if (token) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      localStorage.setItem(STORAGE_KEYS.ROLE, role);
      navigate("/billing");
      window.location.reload();
    } else if (error) {
      alert('Login failed: ' + error);
      navigate('/login');
    }
  }, [navigate]);

  return <p>Logging in...</p>;
};

export default AuthCallback;
